import { Chip, IconButton, Typography } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Edit } from "@mui/icons-material";

/**
 * Calcula el total de pisos de un cliente sumando los pisos de cada edificio.
 */
export const getTotalFloors = (client) => {
  return (
    client.locations?.reduce(
      (sum, loc) =>
        sum +
        loc.buildings?.reduce(
          (bSum, building) => bSum + (parseInt(building.floors) || 0),
          0
        ),
      0
    ) || 0
  );
};

/**
 * Retorna las columnas de la tabla de clientes traducidas.
 * 
 * @param {Function} toggleRowExpansion - Función para expandir/colapsar filas.
 * @param {Object} expandedRows - Estado de las filas expandidas.
 * @param {Function} handleEdit - Función para editar un cliente.
 * @param {Boolean} isAdmin - Indica si el usuario actual es administrador.
 * @param {Function} t - Función de traducción (i18n).
 * @returns {Array} Columnas de la tabla.
 */
export const getTableColumns = (
  toggleRowExpansion,
  expandedRows,
  handleEdit,
  isAdmin,
  t
) => {
  const baseColumns = [
    {
      Header: "",
      id: "expander",
      width: 50,
      Cell: ({ row }) => (
        <IconButton
          size="small"
          onClick={() => toggleRowExpansion(row.original.id)}
          sx={{ ml: 1 }}
        >
          {expandedRows[row.original.id] ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          )}
        </IconButton>
      ),
    },
    {
      Header: t("name"),
      accessor: "name",
      Cell: ({ value }) => (
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {value}
        </Typography>
      ),
    },
    {
      Header: t("email"),
      accessor: "email",
      Cell: ({ value }) => <Typography variant="body2">{value}</Typography>,
    },
    {
      Header: t("phone"),
      accessor: "phone",
      Cell: ({ value }) => <Typography variant="body2">{value}</Typography>,
    },
    {
      Header: t("location"),
      accessor: "locations",
      Cell: ({ value }) => (
        <Chip
          label={value?.length || 0}
          color="primary"
          size="small"
          sx={{ minWidth: 60 }}
        />
      ),
    },
    {
      Header: t("building"),
      accessor: (row) =>
        row.locations?.reduce(
          (sum, loc) => sum + (loc.buildings?.length || 0),
          0
        ),
      Cell: ({ value }) => (
        <Chip
          label={value || 0}
          color="secondary"
          size="small"
          sx={{ minWidth: 60 }}
        />
      ),
    },
    {
      Header: t("elevator"),
      accessor: (row) =>
        row.locations?.reduce(
          (sum, loc) =>
            sum +
            (loc.buildings?.reduce(
              (bSum, building) => bSum + (building.elevators?.length || 0),
              0
            ) || 0),
          0
        ),
      Cell: ({ value }) => (
        <Chip
          label={value || 0}
          color="success"
          size="small"
          sx={{ minWidth: 60 }}
        />
      ),
    },
  ];

  if (isAdmin) {
    baseColumns.push({
      Header: t("actions"),
      id: "actions",
      Cell: ({ row }) => (
        <IconButton
          color="primary"
          size="small"
          onClick={() => handleEdit(row.original)}
          title={t("editClient")}
        >
          <Edit />
        </IconButton>
      ),
    });
  }

  return baseColumns;
};
